export default __webpack_public_path__ + "static/media/Uppsala_full.4641b5f0.svg";